import { useEffect, useState } from "react";
import { Alert } from "../ds";
import { api, type SystemStatus } from "../lib/api";
import { fmtDateTime } from "../lib/format";

// Zertifikate funktionieren, funktionieren, und dann fällt an einem
// Dienstagmorgen die halbe Flotte raus. Deshalb steht der Ablauf dort, wo ihn
// jemand sieht — und nur dann, wenn er bald ansteht.

function meldungen(s: SystemStatus): { ton: "warning" | "danger"; text: string }[] {
  const raus: { ton: "warning" | "danger"; text: string }[] = [];

  if (s.agentCert?.warn) {
    const abgelaufen = s.agentCert.daysLeft <= 0;
    raus.push({
      ton: abgelaufen ? "danger" : "warning",
      text: abgelaufen
        ? `Das Serverzertifikat für ${s.agentCert.host} ist seit ${fmtDateTime(s.agentCert.notAfter)} abgelaufen — kein Router kommt mehr herein.`
        : `Das Serverzertifikat für ${s.agentCert.host} läuft in ${s.agentCert.daysLeft} Tagen ab (${fmtDateTime(s.agentCert.notAfter)}). Ein Deploy stellt es neu aus; danach muss Caddy neu laden.`,
    });
  }

  if (s.devices.expired > 0) {
    raus.push({
      ton: "danger",
      text: `${s.devices.expired} Router mit abgelaufenem Zertifikat. Die kommen nicht mehr von selbst zurück — sie brauchen ein neues Enrollment.`,
    });
  } else if (s.devices.expiringSoon > 0) {
    raus.push({
      ton: "warning",
      text: `${s.devices.expiringSoon} Router mit bald ablaufendem Zertifikat. Sie erneuern selbst, sobald sie online sind — wer offline bleibt, fällt raus.`,
    });
  }

  return raus;
}

/** Zeigt nichts, solange nichts ansteht. */
export function CertWarning() {
  const [status, setStatus] = useState<SystemStatus | null>(null);

  useEffect(() => {
    api
      .getSystemStatus()
      .then(setStatus)
      .catch(() => setStatus(null));
  }, []);

  if (!status) return null;
  const offen = meldungen(status);
  if (offen.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      {offen.map((m) => (
        <Alert key={m.text} variant={m.ton} title="Zertifikat läuft ab">
          {m.text}
        </Alert>
      ))}
    </div>
  );
}
